import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Thankyou from "./pages/Thankyou";

function App() {
  
  return (
    <>
    <div className="App ">    

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/professional-website-development" element={<Home />} />
        <Route path="/professional-website-development/thankyou" element={<Thankyou />} />
        
      </Routes>
    </div>
    </>
  );
}

export default App;
